import { useTranslation } from 'react-i18next';

import { RequestDetailsForm } from 'support/components';
import { IRequest } from 'support/types';

import { SlidingPanel } from 'coreOld/components';
import { DATE_LONG_FORMAT, formatDate } from 'coreOld/utils';

import {
  Subtitle,
  SubtitleColumn,
  SubtitleWrapper,
  Title,
  TitleWrapper,
} from './requestDetailsStyle';

interface IProps {
  selectedRequest: IRequest;
  onClosePanel: () => void;
}

const RequestDetailsView = ({ selectedRequest, onClosePanel }: IProps) => {
  const { t } = useTranslation();

  return (
    <SlidingPanel isOpen={Boolean(selectedRequest)} onClosePanel={onClosePanel}>
      <TitleWrapper>
        <Title>{t('titleSupportRequestId', { id: selectedRequest?.id })}</Title>

        <SubtitleWrapper>
          <SubtitleColumn>
            <Subtitle>
              {t('titleProjectName', {
                projectName: selectedRequest?.projectName,
              })}
            </Subtitle>
            <Subtitle>{t('titleCreatedByUserName', { name: selectedRequest?.userName })}</Subtitle>
          </SubtitleColumn>
          <SubtitleColumn>
            <Subtitle>
              {t('titleCreatedAt', {
                date: formatDate(selectedRequest?.createdAt, false, DATE_LONG_FORMAT),
              })}
            </Subtitle>
            <Subtitle>
              {t('titleUpdatedAt', {
                date: formatDate(selectedRequest?.updatedAt, false, DATE_LONG_FORMAT),
              })}
            </Subtitle>
          </SubtitleColumn>
        </SubtitleWrapper>
      </TitleWrapper>

      <RequestDetailsForm selectedRequest={selectedRequest} onClosePanel={onClosePanel} />
    </SlidingPanel>
  );
};

export default RequestDetailsView;
